<div class="flex flex-col gap-2 items-center justify-center h-[400px] bg-white rounded-lg shadow-md">
  <ng-container *ngIf="!value; else previewTemplate">
    <mat-icon class="!w-[60px] !h-[60px] text-[60px]">cloud_upload</mat-icon>
    <button type="button" mat-raised-button color="primary" (click)="openFilePicker()">Välj fil</button>
    <span class="text-sm mt-2" *ngIf="infoText">{{ infoText }} </span>
  </ng-container>
</div>

<ng-template #previewTemplate>
  <img [src]="value.getFilePath({w: 500, stream: 'up'}) | secureImg" *ngIf="value.isImage()" (click)="openFilePicker()" class="w-full h-full cursor-pointer object-contain rounded-lg" [alt]="value.title" />
  <div class="flex flex-col items-center justify-center w-[200px] h-[200px]" *ngIf="value.mime === 'application/pdf'">
    <mat-icon class="text-5xl text-gray-500 !w-14 !h-14">picture_as_pdf</mat-icon>
    <span>{{ value.title }}</span>
    <button type="button" mat-button (click)="openFilePicker()">Ändra fil</button>
  </div>
</ng-template>